module.exports = __webpack_public_path__ + "static/img/swiper02.d05f64e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper02.jpg
// module id = 158
// module chunks = 1